import { iconCirclePlus } from "@kensho/icons";
import { Button } from "@kensho/neo";
import { useNavigate } from "react-router";

import { DownloadMediaFileButton } from "../../actions/download-media-file-button";
import { DownloadTranscriptButton } from "../../actions/download-transcript-button";

interface TranscriptRightSidebarProps {
  media?: File;
  transcriptId: string;
  reset: () => void;
}

export function TranscriptRightSidebar(props: TranscriptRightSidebarProps) {
  const { transcriptId, media, reset } = props;
  const navigate = useNavigate();

  return (
    <aside className="flex w-44 flex-col gap-2">
      <DownloadTranscriptButton />
      {/* New Transcription */}
      <Button
        onClick={() => {
          reset();
          navigate("/transcriptions/new/batch");
        }}
        icon={iconCirclePlus}
      >
        Create new
      </Button>
      <DownloadMediaFileButton mediaFile={media} name={transcriptId} />
    </aside>
  );
}
